import { HisDdDirective } from './../../../core/directive/his-dd.directive';
import { HisBaseGlobalsService } from './../../../core/service/base/his-base-globals.service';
import { HisDynamicFieldBase } from '../../model/field-base';
import { Component, OnInit, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisDynamicFieldConfig } from '../../model/formfield';
import { HisDynamicFieldConfigAndData } from '../../model/field-config-and-data';
import { Validators } from '@angular/forms';

@Component( {
    template: `
        <his-plam [label]="options.label" [helptext]="options.helptext" [showLabelTop]="options.showLabelTop">
            <textarea #content
                [hisDdKey]="ddKey"
                [formControl]="formControl"
                [rows]="options.height"
                class="textareaWidth100">
            </textarea>
        </his-plam>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class TextAreaComponent extends HisDynamicFieldBase<string> implements OnInit {
    private hbgs: HisBaseGlobalsService;

    @ViewChild( HisDdDirective ) ddDirective: HisDdDirective;

    options: HisDynamicFieldConfig;

    constructor() {
        const injectedData = inject<HisDynamicFieldConfigAndData>('injectedData' as any);
        const hbgs = inject(HisBaseGlobalsService);

        super( injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs );
        this.hbgs = hbgs;

        this.options = injectedData.options;
    }

    ngOnInit() {
        super.initFormControl( this.value );
    }

    updateConfiguration( entireFormConfig: HisDynamicFieldConfig ) {
        let matchingConfig = this.searchFieldConfig( entireFormConfig );
        if ( matchingConfig !== null ) {
            this.formControl.setValue( matchingConfig.defaultValue, { emitEvent: false } );
        }
    }

    setRequired( state: boolean ): void {
        if ( this.options.ddKey ) {
            this.hbgs.setRequiredToDdEntry( this.ddKey, state );
            this.ddDirective.notifyDdKeyOrContextsChanged();
        }
        this.formControl.setValidators( state ? Validators.required : [] );
        this.formControl.markAsDirty();
    }

    getControlValue(): any {
        return this.formControl.value;
    }
}
